import { gql } from "@apollo/client";
import { SearchSelect } from "./SearchSelect";
import { AdVariationSearchSelect_SearchAdVariationsQuery, AdVariationSearchSelect_SearchAdVariationsQueryVariables } from "../../../../codegen/graphql";
import client from "../../../graphqlClient";
import { getTranslatedValue } from "../TranslatedValue";

const SEARCH_AD_VARIATIONS = gql`
  query AdVariationSearchSelect_SearchAdVariations($adId: ID) {
    variations(adId: $adId) {
      id
      variationTypeValues {
        id
        value
      }
    }
  }
`;

export type AdVariationSearchSelect_AdVariationOption = AdVariationSearchSelect_SearchAdVariationsQuery['variations'][number];

function getVariationLabel(option: AdVariationSearchSelect_AdVariationOption): string {
  return option.variationTypeValues.map((v) => getTranslatedValue(v.value)).join(" / ") || option.id;
}

export default function AdVariation_SearchSelect({
  selectedAdVariation,
  onAdVariationChange,
  adId,
}: {
  selectedAdVariation: AdVariationSearchSelect_AdVariationOption | null;
  onAdVariationChange: (adVariation: AdVariationSearchSelect_AdVariationOption | null) => void;
  adId?: string;
}) {
  // Load ads for search
  const loadAds = async (searchText: string) => {
    if (
      searchText.trim().length < 3
      && !adId
    ) {
      return [];
    }
    
    const result = await client.query<
      AdVariationSearchSelect_SearchAdVariationsQuery,
      AdVariationSearchSelect_SearchAdVariationsQueryVariables
    >({
      query: SEARCH_AD_VARIATIONS,
      variables: { adId },
      fetchPolicy: 'network-only'
    });

    if (!result.data) {
      throw new Error('No data returned from searchAdVariations');
    }

    return result.data.variations;
  };
  return (
    <SearchSelect<AdVariationSearchSelect_AdVariationOption>
      loadOptions={loadAds}
      value={
        selectedAdVariation || null
      }
      onSelect={(option) => onAdVariationChange(option)}
      onClear={() => onAdVariationChange(null)}
      renderOption={(option, selectCallback) => (
        <div className='px-2 py-1' onClick={selectCallback}>
          {getVariationLabel(option)}
        </div>
      )}
      renderSelected={(option) => getVariationLabel(option)}
      label="Ad Variation"
      placeholder="Search for an ad variation..."
    />
  )
}